import { motion, type Variants } from "framer-motion";
import { Monitor } from "lucide-react";

const containerVariants: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08, delayChildren: 0.04 } },
};
const itemVariants: Variants = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 220, damping: 22 } },
};

export default function LandingHero() {
  return (
    <motion.section
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      aria-label="SyncScreen introduction"
      className="flex flex-col items-center text-center gap-5"
    >
      {/* Minimal live badge — single small pill */}
      <motion.div variants={itemVariants}>
        <div className="inline-flex items-center gap-2 glass-tertiary is-active rounded-full px-3.5 py-1.5 text-[11px] font-medium tracking-wide text-foreground/90">
          <span className="relative flex h-1.5 w-1.5">
            <span aria-hidden className="absolute inline-flex h-full w-full rounded-full bg-[#78B4FF] opacity-60 animate-ping" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#78B4FF]" />
          </span>
          <span className="text-muted-foreground">Real-time synchronized video</span>
        </div>
      </motion.div>

      {/* Brand mark — soft glowing glass tile */}
      <motion.div variants={itemVariants} className="relative">
        <div
          aria-hidden
          className="absolute inset-0 -z-10 blur-2xl opacity-50 scale-110 rounded-2xl"
          style={{ background: "radial-gradient(circle at 50% 50%, rgba(120,180,255,0.18), transparent 65%)" }}
        />
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl glass-primary glass-highlight-edge overflow-hidden">
          <Monitor className="h-6 w-6 text-[#78B4FF]" />
        </div>
      </motion.div>

      {/* Title — strong but not oversized, clean Apple-like */}
      <motion.h1
        variants={itemVariants}
        className="text-[2rem] font-semibold tracking-[-0.03em] sm:text-[2.6rem] leading-[1.05] text-foreground"
      >
        Watch together,
        <br className="hidden sm:block" />
        <span className="text-muted-foreground"> in perfect sync.</span>
      </motion.h1>

      {/* Subtitle — medium-weight, muted */}
      <motion.p
        variants={itemVariants}
        className="max-w-[520px] text-[13.5px] sm:text-[14.5px] leading-relaxed text-muted-foreground"
      >
        YouTube, MP4 and HLS in sync with friends — floating chat, shared queue,
        live polls, and reactions that drift over the video.
      </motion.p>
    </motion.section>
  );
}
